import { faker } from "@faker-js/faker";

/* Config */

/* Components */

/* APIs - Hooks - Utils */
import { PullRequest } from "./metadataApi";
import { Status } from "../dashboard/dashboardApi";

const statusOptions: Status["status"][] = ["up", "down", "slow", "unknown"];

export const mockStatuses: Status[] = Array.from(
  { length: 50 },
  (_, index) => ({
    id: index + 1,
    // Error on faker.helpers.arrayElement(statusOptions). Workaround by using Math.random
    status: statusOptions[Math.floor(Math.random() * statusOptions.length)],
    monitor: faker.number.int({ min: 1, max: 10 }),
    response_time_avg: Number(
      faker.number.float({ min: 0.1, max: 5 }).toFixed(1)
    ),
    last_updated: faker.date.recent().toISOString(),
  })
);

const stateOptions: PullRequest["state"][] = ["open", "closed"];

export const mockPullRequests: PullRequest[] = Array.from(
  { length: 50 },
  (_, index) => ({
    number: index + 1,
    title: faker.lorem.sentence(),
    state: stateOptions[Math.floor(Math.random() * stateOptions.length)],
    author: faker.internet.username(),
    created_at: faker.date.past({ years: 1 }).toISOString(),
    url: `https://github.com/${faker.internet.username()}/${faker.lorem.slug()}/pull/${faker.number.int(
      { min: 1, max: 10000 }
    )}`,
    head_ref: faker.git.branch(),
    base_ref: faker.git.branch(),
    draft: faker.datatype.boolean(),
    merged_at: faker.datatype.boolean()
      ? faker.date.recent().toISOString()
      : null,
  })
);

export const mockAppInfo = {
  name: faker.company.name(),
  version: faker.system.semver(),
  description: faker.lorem.sentence(),
  authors: {
    [faker.internet.username()]: faker.internet.email(),
    [faker.internet.username()]: faker.internet.email(),
    [faker.internet.username()]: faker.internet.email(),
  },
  user_manual_url: faker.internet.url(),
};
